import {ConfirmationDialog} from '@primer/react'
import {useCallback} from 'react'
import {useRelayEnvironment} from 'react-relay'

import {unblockUserFromOrganization} from '../../mutations/unblock-user-from-organization-mutation'

type UnblockUserFromOrgDialogProps = {
  organization: {login: string; id: string}
  contentAuthor: {login: string; id: string}
  onClose: () => void
  onCompleted?: () => void
}

export const UnblockUserFromOrgDialog = ({
  contentAuthor,
  organization,
  onClose,
  onCompleted,
}: UnblockUserFromOrgDialogProps) => {
  const environment = useRelayEnvironment()

  const onDialogClose = useCallback(
    (gesture: 'confirm' | 'cancel' | 'close-button' | 'escape') => {
      if (gesture === 'confirm') {
        unblockUserFromOrganization({
          environment,
          input: {unblockedUserId: contentAuthor.id, organizationId: organization.id},
          onCompleted,
        })
      }
      onClose()
    },
    [onClose, environment, contentAuthor.id, organization.id, onCompleted],
  )

  return (
    <ConfirmationDialog
      title={`Unblock ${contentAuthor.login} from ${organization.login}`}
      confirmButtonContent={'Unblock user'}
      confirmButtonType="danger"
      onClose={onDialogClose}
    >
      Are you sure you want to unblock <strong>{contentAuthor.login}</strong> from <strong>{organization.login}</strong>
      ?
    </ConfirmationDialog>
  )
}

try{ UnblockUserFromOrgDialog.displayName ||= 'UnblockUserFromOrgDialog' } catch {}